export class CommunityPolicy {
  private readonly isEventPeriod: boolean = false;
  private readonly eventDiaryPoint: number = 0;

  /** 내 크리에이터(집밥일기) 페이지 경로 */
  static readonly CREATOR_PAGE_PATH = '/mypages/creator';

  /**
   * 북마크를 켜고 끈 뒤 보여주는 토스트 문구.
   * 화면마다 따로 쓰면 같은 동작이 "북마크했습니다"와 "북마크에 추가했어요"로 갈라져 보인다.
   */
  static getBookmarkToastMessage({
    recipeName,
    isBookmarked,
  }: {
    recipeName: string;
    /** 누른 뒤의 상태 */
    isBookmarked: boolean;
  }) {
    return `${recipeName} 레시피를 ${
      isBookmarked ? '북마크했습니다.' : '북마크 제외했습니다.'
    }`;
  }

  /** 집밥일기 1회 작성시 기존 포인트 */
  static originDiaryPoint = 50;
  /** 레시피 1회 작성시 포인트 */
  static recipePoint = 300;
  /** 집밥일기 작성시 참고레시피 첨부할 경우 포인트 */
  static referencingRecipePoint = 10;
  /** 집밥일기 포인트 수령 가능 횟수 */
  static countOfDiaryBenefit = 3;

  constructor(eventProps?: {
    isEventPeriod: boolean;
    eventDiaryPoint: number;
  }) {
    if (eventProps) {
      this.isEventPeriod = eventProps.isEventPeriod;
      this.eventDiaryPoint = eventProps.eventDiaryPoint;
    }
  }

  /**
   * 집밥일기 1회 작성시 포인트
   */
  getDiaryPoint() {
    if (this.isEventPeriod) {
      return this.eventDiaryPoint;
    }
    return CommunityPolicy.originDiaryPoint;
  }

  /**
   * 집밥일기 1회 작성시 최대 수령 가능 포인트
   */
  get maxPointOfOneDiary() {
    return this.getDiaryPoint() + CommunityPolicy.referencingRecipePoint;
  }

  /**
   * 오더 1회당 집밥일기 작성 최대 수령가능 포인트
   */
  get maxDiaryPointForOneOrder() {
    return this.maxPointOfOneDiary * CommunityPolicy.countOfDiaryBenefit;
  }
}
